/* eslint-disable */
export default {
  cancel: 'キャンセル',
  pmiChangeConfirmed: '変更',
  pmiChangeConfirmTitle: '個人会議の設定を変更しますか？',
  pmiChangeConfirmContext:
    '設定を変更すると、既にスケジュールされたものも含め、この個人会議IDまたは名前を使用するすべての会議に影響します',
  updatePassword: 'パスワードを更新',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
